import { render, staticRenderFns } from "./studyRecordCount.vue?vue&type=template&id=3fd64918&scoped=true&"
import script from "./studyRecordCount.vue?vue&type=script&lang=js&"
export * from "./studyRecordCount.vue?vue&type=script&lang=js&"
import style0 from "./studyRecordCount.vue?vue&type=style&index=0&id=3fd64918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd64918",
  null
  
)

export default component.exports